import {
  MessageSquare,
  Inbox,
  Stethoscope,
  Phone,
  Users,
  BarChart3,
  Calculator,
  GraduationCap,
  Bug
} from 'lucide-react';

// Format → icon. Labels live in strings.js (`formats`).
export const FORMAT_ICONS = {
  messenger: MessageSquare,
  helpdesk: Inbox,
  ward: Stethoscope,
  phone: Phone,
  pipeline: Users,
  dashboard: BarChart3,
  ledger: Calculator,
  classroom: GraduationCap,
  studio: Bug
};
